"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CasinoFreeToPlayGameStage = void 0;
var CasinoFreeToPlayGameStage;
(function (CasinoFreeToPlayGameStage) {
    CasinoFreeToPlayGameStage["MiniArena"] = "miniArena";
    CasinoFreeToPlayGameStage["DailyWish"] = "dailyWish";
    CasinoFreeToPlayGameStage["DepositWheel"] = "depositWheel";
})(CasinoFreeToPlayGameStage || (exports.CasinoFreeToPlayGameStage = CasinoFreeToPlayGameStage = {}));
//# sourceMappingURL=casino-free-to-play.interfaces.js.map